import {DashBoardMain} from './DashBoard';
export default DashBoardMain;